import type { ComponentProps } from 'react';

import { cn } from '../lib/cn';

/**
 * 1초 이상 걸리는 작업(온보딩 분석, 리뷰 생성, Q&A, 슬라이드 생성)은
 * 진행 상태를 표시해야 한다 — L2-06 §8 비동기 처리 표시.
 */
export function Skeleton({ className, ...props }: ComponentProps<'div'>) {
  return (
    <div
      aria-hidden="true"
      className={cn('bg-line/60 rounded-md motion-safe:animate-pulse', className)}
      {...props}
    />
  );
}
